import React, { useState, useCallback, useEffect } from 'react';
import { PDFViewer, Document, Page,Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
import * as apiClient from "../../../common/apiClient";
import GrandTotal from './GrandTotal'
import AmountInWords from './AmountInWords'
import BankDetail from './BankDetail'
import BankAccountDetail from './BankAccountDetail'
import Signature from './Signature'
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from '@david.kucsai/react-pdf-table'
import logo from '../../../images/logo.png'
import logo_ins from '../../../images/logo_ins.png'


const styles = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingBottom: 50,
    paddingHorizontal: 5,
    paddingRight: 15,
    paddingLeft: 30,

  },
  headercontainer: {
    height: 100,
    flexDirection: "row", 
  },
  headercontainer1: {
    height: 50,
    flexDirection: "row", 
  },
  logocontainer: {
    height: 100,
    width:"50%",
    
  },
  logocontainer1: {
    height: 0,
    width:"0%",
    
  },
  companyaddress:{
    height: 100,
    width:"50%",
    textAlign:'left',
    fontSize: 9,
    marginLeft:10,
    
  },
  companyaddress1:{
    height: 50,
    width:"100%",
    textAlign:'center',
    fontSize: 9,
    marginLeft:10,
    
  },
  invoiceHeader: {
    fontSize: 10,
    height: 20,
    textAlign: 'center',
    fontWeight: "bold",
    borderTop: 1,
    borderLeft: 1,
    borderRight: 1,
    flexDirection: "column",

  },
  partyBox:
  {
    flexDirection: "row",
    height: "100",
    border: 1,
    paddingLeft: 10
  },
  partyBoxAddress:
  {
    flexDirection: "column",
    height: "100",
    width: "70%",


  },
  partyBoxAddress1:
  {
    height: "70%",
    width: "100%",
    fontSize: 10,
    paddingTop: 10,
  },
  billingMonth:
  {
    height: "30%",
    width: "100%",
    fontSize: 10,
    textAlign: "right",
    paddingRight: 10,
    paddingTop: 10

  },
  invoiceDetail:
  {
    flexDirection: "column",
    height: "100",
    borderLeft: 1,
    width: "30%",
    fontSize: 8
  },
  invoiceDetailbox1:
  {
    height: "20%",
    borderBottom: 1,
    textAlign: "center",
  },
  invoiceDetailbox2:
  {
    height: "20%",
    textAlign: "center",
  },
  invoiceDetailDate:
  {
    height: "30%",
    textAlign: "center",
  },
  invoiceDetailRow:
  {
    flexDirection: "row",
    height: "25%",
    borderBottom: 1,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 4,
    alignItems: "center",
    fontWeight: "bold",
  },
  invoiceDetailRowLast:
  {
    borderBottom: 0,
  },
  invoiceDetailLabel:
  {
    width: "50%",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: 8,
  },
  invoiceDetailValue:
  {
    width: "50%",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: 8,
  },
  claimMonthBox:
  {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
    fontSize: 10,
    fontWeight: "bold",
    padding: 5,
  },

  tableHeaderStyle:
  {

    flexDirection: "row",
    textAlign: "center",
    width: "100%",
    fontSize: 8,
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1

  },
  tableHeaderStylebox1:
  {
    paddingTop: 3,
    textAlign: "center",
    width: "8%",
    borderRight: 1,
    fontSize: 9
  },

  tableHeaderStylebox2:
  {
    paddingTop: 3,
    textAlign: "right",
    // height: "10%",
    width: "9%",
    fontSize:8,
    borderRight: 1,

  },
  tableHeaderStyleParticularsDetail:
  {
    width: "28%",
    textAlign: "left",
  },
  tableHeaderStyleParticularsSummary:
  {
    width: "72%",
    textAlign: "left",
  },
  tableHeaderStylebox2_1_1:
  {
    padding: 3,
    textAlign: "left", 
    width: "72%",
    fontSize:8,
    borderRight: 1,

  },
  tableHeaderStylebox2_1:
  {
    paddingTop: 3,
    textAlign: "center",
    // height: "10%",
    width: "8%",
    fontSize:8,
    borderRight: 1,

  },
  tableHeaderStylebox3:
  {
    paddingTop: 3,
    textAlign: "center",
    width: "20%",
    borderRight: 1
  },
  tableRow:
  {

    flexDirection: "column",
    width: "100%",
    borderBottom: 1,

  },
  tableRowStyle:
  {

    flexDirection: "row",
    textAlign: "center",
    width: "100%",
    fontSize: 8,
    borderBottom: 1,
    borderLeft: 1,
    minHeight: 5

  },
  tableRowStylebox1:
  {
    paddingRight: 5,
    paddingTop: 5,
    textAlign: "center",
    width: "8%",
    borderRight: 1,
    fontSize:8,
  },
  tableRowStyleClaimTypeNarrow:
  {
    paddingRight: 3,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "center",
    width: "8%",
    borderRight: 1,
    borderLeft: 0,
    fontSize: 9,
  },
  tableRowStyleParticularsWide:
  {
    paddingRight: 3,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "left",
    width: "28%",
    borderRight: 1,
    borderLeft: 0,
    fontSize: 9,
  },

  tableRowStylebox2:
  {
    paddingRight: 5,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "right",
    width: "9%", 
    borderRight:1,
    borderLeft:0,
    fontSize:8,
    height:30

  },
  tableRowStylebox2_1:
  {
    paddingRight: 5,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "left",
    width: "24%", 
    borderRight:1,
    borderLeft:0,
    fontSize:8,
    height:30

  },
  tableRowStylebox3:
  {

    textAlign: "right",
    width: "20%",
    borderRight: 1,
    paddingRight: 3,
    paddingTop: 5
  },
  tableRowStylebox2Total:
  {
    paddingRight: 5,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "right",
    width: "72%",
    fontWeight: "bold",
    fontSize: 10

  },
  tableRowStylebox3TotalAmount:
  {
    textAlign: "right",
    width: "20%",
    borderLeft: 1,
    borderRight: 1,
    borderTop: 1,
    paddingRight: 3,
    paddingTop: 5,
    fontSize: 8

  },
  tableRowStylebox2Tax:
  {
    flexDirection: "row",
    paddingRight: 0,
    paddingTop: 0,
    paddingLeft: 0,
    textAlign: "right",
    width: "72%",
    fontWeight: "bold",
    fontSize: 8

  },
  tableRowStylebox2TaxEmptyBox:
  {
    paddingRight: 5,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "right",
    width: "50%",
    fontWeight: "bold",
    fontSize: 8

  },
  tableRowStylebox2Taxdetail:
  {
    paddingRight: 3,
    paddingTop: 5,
    paddingLeft: 3,
    textAlign: "right",
    width: "50%",
    fontWeight: "bold",
    fontSize: 10,
    borderLeft: 1,
    borderRight: 0,
    borderTop: 1,
    borderBottom: 1,


  },
  tableRowStylebox3Taxamount:
  {

    textAlign: "right",
    width: "20%",
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
    paddingRight: 3,
    paddingTop: 50
  },
  tableRowStylewith5height:
  {

    flexDirection: "row",
    textAlign: "center",
    width: "100%",
    fontSize: 8,
    borderBottom: 0,
    borderLeft: 1,
    borderTop: 1,
    minHeight: 5

  },
  tableHeaderStylebox2GrandTotal:
  {
    paddingTop: 3,
    paddingRight: 3,
    textAlign: "right",
    width: "70%",
    fontSize: 10

  },
  tableHeaderStylebox3GrandTotal:
  {
    paddingTop: 3,
    paddingRight: 3,
    textAlign: "right",
    width: "22%",
    borderLeft: 1,
    borderRight: 1,
    fontSize: 10
  },
  boxAmountinWords:
  {
    flexDirection: "row",
    paddingTop: 12,
    paddingRight: 3,
    paddingLeft: 3,
    textAlign: "left",
    width: "100%",
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
    height: 30,
    fontSize: 8
  },
  bankDetailBox:
  {
    flexDirection: "column",
    paddingTop: 12,
    paddingRight: 1,
    paddingLeft: 1,
    textAlign: "left",
    width: "100%",
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
    borderTop: 0,
    height: 30,
    fontSize: 8
  },
  bankAccountDetailBox:
  {
    flexDirection: "row",

    textAlign: "left",
    width: "100%",
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
    borderTop: 0,
    height: 15,
    fontSize: 8
  },
  bankAccountDetailBox1:
  {

    paddingRight: 3,
    paddingLeft: 3,
    textAlign: "center",
    width: "35%",
    borderRight: 1,
    borderTop: 0,
    fontSize: 9
  },
  bankAccountDetailBox2:
  {


    paddingRight: 3,
    paddingLeft: 3,
    textAlign: "center",
    width: "20%",
    borderRight: 1,
    borderTop: 0,
    fontSize: 9
  },
  bankAccountDetailBox3:
  {


    paddingRight: 3,
    paddingLeft: 3,
    textAlign: "center",
    width: "25%",
    borderRight: 1,
    borderTop: 0,
    borderTop: 0,
    fontSize: 9
  },
  bankAccountDetailBox4:
  {


    paddingRight: 3,
    paddingLeft: 3,
    textAlign: "center",
    width: "20%",
    borderRight: 1,
    borderTop: 0,
    fontSize: 9
  },
  signatureBox:
  {
    flexDirection: "column",
    paddingTop: 12,
    paddingRight: 3,
    paddingLeft: 3,
    textAlign: "left",
    width: "100%",
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
    borderTop: 0,
    height: 100,
    fontSize: 9
  },
  originalCopyBox:
  {
    textAlign: 'right',
    marginRight: 20,
    marginTop: 4,
  },

});


const InvoicePrint = props => {

  const [isLoading, setLoading] = useState(true);
  const [headerData, setHeaderData] = useState({ partyName: "RedPlus Society,", address: "Baghanjatin Station Road Kolkata-700032 West Bengal", invoiceNo: "HDFC/20-21/JAN/0392R", invoiceDate: "11.11.2021", billMonth: "Month Of December 2020", taxableAmount: "1000.00",IsSummary:true });
  const [detailData, setDetailData] = useState([]);
  const [footerDetail, setFooterDetail] = useState("");
  const [blankRow, setBlankRow] = useState([]);
  
  const [grossAmt, setGrossAmt] = useState(0);
  useEffect(() => { LoadData(props.invoiceId,props.claimInvDetId); }, []);
  const LoadData = async (id,claimInvDetId) => {

    await apiClient.getInvoiceDataForPrint(id,claimInvDetId).then(res => { 
      debugger
      let data = [];   
      setHeaderData(res[0]);
      if(res[0].InvoiceDetails)
      {
        setDetailData(JSON.parse(res[0].InvoiceDetails));
      } 
      
      
      // setDetailData(res.detailData);
      setLoading(false);

    }).catch(err => {
      setLoading(false);
      console.log(err);
    });

  }

  return (
    <React.Fragment>
      <div>
        <div style={{ float: "right" }} onClick={props.onClose}><CancelSharpIcon /></div>
      </div>
      {isLoading === false && headerData!=null && headerData.IsSummary!=undefined ?
        <PDFViewer width="100%" height="600" >
          <Document title="report" >
            <Page size="A4" style={styles.page}>
              <View> 
                <View style={headerData.ReportFooter && headerData.ReportFooter.length>0 ?styles.headercontainer:styles.headercontainer1}> 
                <View style={headerData.ReportFooter?styles.logocontainer:styles.logocontainer1}> 
                <Image style={{ width: 200 }} src={headerData.ReportFooter? headerData.ReportName === 'GST INVOICE'? logo_ins: logo: ""}/>               
               </View>
                {headerData.ReportFooter?
                <View style={headerData.ReportFooter?styles.companyaddress:styles.companyaddress1}> 
                <Text>{headerData.addresses}</Text>
                <Text>{headerData.addresses2}</Text>
                <Text>{headerData.addresses3}</Text>
                <Text>{"Phone:"+headerData.Phone}</Text>
                <Text>{"MSME:"+headerData.MSME}</Text>
                <Text>{"PANNo:"+headerData.PANNO}</Text>
                {headerData.GSTNo != null && headerData.GSTNo != '' && (
                  <Text>{"GSTNo:" + headerData.GSTNo}</Text>
                )}
                <Text>{"Email:"+headerData.Email}</Text>
                <View style={styles.originalCopyBox}>
                <Text>Original Copy</Text>
                </View>
                </View>
                :
                <View style={headerData.ReportFooter && headerData.ReportFooter.length>0 ?styles.companyaddress:styles.companyaddress1}> 
                <Text>{headerData.addresses}</Text>
                <Text>{headerData.addresses2}</Text>
                <Text>{headerData.addresses3}</Text>
                <Text>{"Phone:"+headerData.Phone}</Text>
                </View>
                }
                </View>

                <View wrap={false} style={styles.invoiceHeader} >
                  <Text>{headerData.ReportName}</Text>
                </View>
                <View wrap={false} style={styles.partyBox} >
                  <View style={styles.partyBoxAddress}>
                    <View style={styles.partyBoxAddress1}>
                      <Text>To,</Text>
                      <Text>{headerData.partyName}</Text>
                      <Text>{headerData.address}</Text>
                      <Text style={{marginTop:2}}>{headerData.partyStateCode}</Text>
                      
                      <Text style={{marginTop:10}} >{headerData.partygstno}</Text>
                    </View>
                  </View>
                  <View style={styles.invoiceDetail}>
                    <View style={styles.invoiceDetailRow}>
                      <Text style={styles.invoiceDetailLabel}>Invoice No. :</Text>
                      <Text style={styles.invoiceDetailValue}>{headerData.InvoiceNo}</Text>
                    </View>
                    <View style={styles.invoiceDetailRow}>
                      <Text style={styles.invoiceDetailLabel}>Date :</Text>
                      <Text style={styles.invoiceDetailValue}>{headerData.InvoiceDate}</Text>
                    </View>
                    <View style={styles.invoiceDetailRow}>
                      <Text style={styles.invoiceDetailLabel}>HSN / SAC Code :</Text>
                      <Text style={styles.invoiceDetailValue}>{headerData.HSNCode || headerData.HSNSACCode || headerData.HsnSacCode || headerData.hsnSacCode}</Text>
                    </View>
                    <View style={[styles.invoiceDetailRow, styles.invoiceDetailRowLast]}>
                      <Text style={styles.invoiceDetailLabel}>Place of Supply :</Text>
                      <Text style={styles.invoiceDetailValue}>{headerData.PlaceOfSupply || headerData.PlaceOfSupplyName || headerData.placeOfSupply}</Text>
                    </View>
                  </View>


                </View>
                <View style={styles.claimMonthBox}>
                  <Text>{headerData.billMonth}</Text>
                </View>
                <View wrap={false} style={styles.tableHeaderStyle}>
                  <View style={styles.tableHeaderStylebox1}>
                    <Text>SL No</Text>
                  </View>
                 
                  {!headerData.IsSummary && <View style={styles.tableHeaderStylebox2_1}>
                    <Text>Claim Type</Text>
                  </View>}
                  {/* {headerData.IsSummary && <View style={styles.tableHeaderStylebox2_1_1}>
                    <Text>Particluars</Text>
                  </View>} */}

                  <View style={[styles.tableHeaderStylebox2, headerData.IsSummary ? styles.tableHeaderStyleParticularsSummary : styles.tableHeaderStyleParticularsDetail]}>
                    <Text>Particulars</Text>
                  </View>

                  {!headerData.IsSummary &&
                  <View style={styles.tableHeaderStylebox2}>
                    <Text>Prof. Fees</Text>
                  </View>}
                  {!headerData.IsSummary && <View style={styles.tableHeaderStylebox2}>
                    <Text>TAT Incentive</Text>
                  </View>}
                  {!headerData.IsSummary && <View style={styles.tableHeaderStylebox2}>
                    <Text>Doc Collection Charges</Text>
                  </View>}
                  {!headerData.IsSummary && <View style={styles.tableHeaderStylebox2}>
                    <Text>Extra Conveyance</Text>
                  </View>  }
                  <View style={styles.tableHeaderStylebox3}>
                    <Text>Amount (Rs)</Text>
                  </View>

                </View>
                <View style={styles.tableRow}>
                  {detailData.map((item, index) => {
                    return <View key={index} wrap={false} style={styles.tableRowStyle}>
                      <View style={styles.tableRowStylebox1}>
                        <Text> {index + 1}</Text>
                      </View>
                      {!headerData.IsSummary && <View style={styles.tableRowStyleClaimTypeNarrow}>
                        <Text>{item.ClaimType}</Text>
                      </View> }
                      {!headerData.IsSummary && <View style={styles.tableRowStyleParticularsWide}>
                        <Text>{item.ClaimNo}</Text>
                      </View> }
                      {headerData.IsSummary && <View style={styles.tableHeaderStylebox2_1_1}>
                        <Text>{item.ClaimType}</Text>
                        <Text>{item.ClaimNo}</Text>
                      </View> }
                      {/* <View style={styles.tableRowStylebox2}>
                        <Text>{item.ClaimNo}</Text>
                      </View> */}
                      {headerData!=null && headerData.IsSummary!=undefined &&   headerData.IsSummary===false && 
                      <View style={styles.tableRowStylebox2}>
                        <Text>{item.Amount}</Text>
                      </View>}
                      {headerData!=null && headerData.IsSummary!=undefined &&   headerData.IsSummary===false &&  <View style={styles.tableRowStylebox2}>
                        <Text>{item.TatIncentiveAmount}</Text>
                      </View> }
                      {headerData!=null && headerData.IsSummary!=undefined &&   headerData.IsSummary===false &&  <View style={styles.tableRowStylebox2}>
                        <Text>{item.ExtraConveyance}</Text>
                      </View> }
                      {headerData!=null && headerData.IsSummary!=undefined &&   headerData.IsSummary===false &&  <View style={styles.tableRowStylebox2}>
                        <Text>{item.DocumentAmount}</Text>
                      </View>}
                      <View style={styles.tableRowStylebox3}>
                        <Text>{item.FinalAmount?item.FinalAmount.toFixed(2):"0.00"}</Text>
                       
                      </View>
                    </View>
                  })}
                  
                  {headerData.ReportFooter && headerData.DeductionAmount?
                  <View wrap={false} style={styles.tableRowStylewith5height}>
                    <View style={styles.tableRowStylebox1}>
                      <Text> </Text>
                    </View>
                    <View style={styles.tableRowStylebox2Total}>
                      <Text>Deduction Amount</Text>
                    </View>
                    <View style={styles.tableRowStylebox3TotalAmount}>
                      <Text>{headerData.DeductionAmount.toFixed(2)}</Text>
                    </View>
                  </View>:<View></View>}
                  {headerData.ReportFooter?
                  <View wrap={false} style={styles.tableRowStylewith5height}>
                    <View style={styles.tableRowStylebox1}>
                      <Text> </Text>
                    </View>
                    <View style={styles.tableRowStylebox2Total}>
                      <Text>{headerData.ReportFooter?"Taxable Value":""}</Text>
                    </View>
                    <View style={styles.tableRowStylebox3TotalAmount}>
                      <Text>{headerData.TaxableAmount?headerData.TaxableAmount.toFixed(2):"0.00"}</Text>
                    </View>
                  </View>:<View></View>}

                  {/* Tax rows - CGST, SGST/UTGST and IGST are always shown, each on its own line */}
                  {headerData.ReportFooter?
                  <View wrap={false} style={styles.tableRowStylewith5height}>
                    <View style={styles.tableRowStylebox1}>
                      <Text> </Text>
                    </View>
                    <View style={styles.tableRowStylebox2Total}>
                      <Text>Add (+)   CGST @ {headerData.CGSTPer?headerData.CGSTPer.toFixed(0):"0"}% on Taxable value</Text>
                    </View>
                    <View style={styles.tableRowStylebox3TotalAmount}>
                      <Text>{headerData.CGSTAmt?headerData.CGSTAmt.toFixed(2):"0.00"}</Text>
                    </View>
                  </View>:<View></View>}
                  {headerData.ReportFooter?
                  <View wrap={false} style={styles.tableRowStylewith5height}>
                    <View style={styles.tableRowStylebox1}>
                      <Text> </Text>
                    </View>
                    <View style={styles.tableRowStylebox2Total}>
                      <Text>Add (+)   SGST/UTGST @ {headerData.SGSTPer?headerData.SGSTPer.toFixed(0):"0"}% on Taxable value</Text>
                    </View>
                    <View style={styles.tableRowStylebox3TotalAmount}>
                      <Text>{headerData.SGSTAmt?headerData.SGSTAmt.toFixed(2):"0.00"}</Text>
                    </View>
                  </View>:<View></View>}
                  {headerData.ReportFooter?
                  <View wrap={false} style={styles.tableRowStylewith5height}>
                    <View style={styles.tableRowStylebox1}>
                      <Text> </Text>
                    </View>
                    <View style={styles.tableRowStylebox2Total}>
                      <Text>Add (+)   IGST @ {headerData.IGSTPer?headerData.IGSTPer.toFixed(0):"0"}% on Taxable value</Text>
                    </View>
                    <View style={styles.tableRowStylebox3TotalAmount}>
                      <Text>{headerData.IGSTAmt?headerData.IGSTAmt.toFixed(2):"0.00"}</Text>
                    </View>
                  </View>:<View></View>}

                  <View wrap={false} style={styles.tableRowStylewith5height}>
                    <View style={styles.tableRowStylebox1}>
                      <Text> </Text>
                    </View>
                    <View style={styles.tableRowStylebox2Total}>
                      <Text>Rounded Off</Text>
                    </View>
                    <View style={styles.tableRowStylebox3}>
                      <Text>{headerData.roundOffAmount?headerData.roundOffAmount:"0.00"} </Text>
                    </View>
                  </View>


                </View>
                <GrandTotal styles={styles} amount={headerData.finalAmount} />
                <AmountInWords styles={styles} amountInWord={headerData.amountinWord} />
                <BankDetail styles={styles} />
                <BankAccountDetail styles={styles} data={headerData} />
                <Signature styles={styles} data={headerData} />

              </View>
            </Page>
          </Document>
        </PDFViewer> : null}
    </React.Fragment>
  );
}

export default InvoicePrint;
